export const SEARCH_STAGES = [
  "DRAFTS",
  "QUESTIONS",
  "PENDING",
  "PAYMENT",
  "SIGNATURE",
  "POST_SALES",
  "COMPLETED",
  "DISCARDED",
  "TELESUBSCRIPTION",
] as const;

export type SearchStage = (typeof SEARCH_STAGES)[number];

export const SEARCH_STAGE_LABELS: Record<SearchStage, string> = {
  DRAFTS: "Drafts",
  QUESTIONS: "Questions",
  PENDING: "Pending",
  PAYMENT: "Payment",
  SIGNATURE: "Signature",
  POST_SALES: "Post sales",
  COMPLETED: "Completed",
  DISCARDED: "Discarded",
  TELESUBSCRIPTION: "Telesubscription",
};

export type AllLeadsRow = {
  id: number;
  ulid: string;
  fullname: string;
  brokerName: string | null;
  email: string | null;
  idNumber: string | null;
  carrier: string | null;
  market: string | null;
  status: string | null;
  date: string | null;
  subscription_status: string | null;
  capital: number | null;
  coverage: string | null;
  subscriptionId: string | null;
  capitals: Record<string, number>;
};

export type AllLeadsResponse = {
  count: number;
  results: AllLeadsRow[];
  limit: number;
  offset: number;
};
